import React from 'react';
import { map } from 'lodash';
import ThicknessIcon from './ThicknessIcon';

export const thicknessOptions = map(
  [
    { key: 's', label: 'Small', pencilPx: 4, highlighterPx: 24 },
    { key: 'm', label: 'Medium', pencilPx: 8, highlighterPx: 48 },
    { key: 'l', label: 'Large', pencilPx: 16, highlighterPx: 96 },
    { key: 'xl', label: 'XL', pencilPx: 32, highlighterPx: 192 },
  ],
  ({ key, label, pencilPx, highlighterPx }) => ({
    key,
    label,
    pencilPx,
    highlighterPx,
    icon: () => <ThicknessIcon label={key} />,
  })
);
